import { Component, OnInit } from '@angular/core';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss']
})
export class DemoComponent implements OnInit {
  pdfSrc = 'assets/files/CDLT_Demo_screen_flow_1.pdf';
  pdf: PDFDocumentProxy;

  constructor() { }

  ngOnInit() { }

  onDownlaodPdf() {
    const link = document.createElement('a');
    link.href = this.pdfSrc;
    link.download = "CDLT_Demo_screen_flow.pdf";
    link.click();
  }
}
